/** Exibir aba e painel Google Agenda no painel de leads (OAuth + slots). */
export const SHOW_GOOGLE_CALENDAR_UI = false;
